import { Component } from '@angular/core';

@Component({
  selector: 'fcp-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent {
}
